import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { fontFamily, radius } from "@passfirst/ui";

import type { ReadinessVerdict } from "../home/use-readiness";
import { type Colors, useColors } from "../theme";

interface Props {
  readiness: ReadinessVerdict;
  label: string;
}

// Colored pill chip — amber-soft for "almost", green-soft for "ready",
// brick-soft for "not-ready." Muted on purpose; bright fills trigger
// test-anxiety arousal (brief).
export function VerdictPill({ readiness, label }: Props): JSX.Element {
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const bg =
    readiness === "ready"
      ? colors.surfaceCorrect
      : readiness === "almost"
        ? colors.surfaceCaution
        : colors.surfaceWrong;
  const text =
    readiness === "ready"
      ? colors.verdictReady
      : readiness === "almost"
        ? colors.verdictAlmost
        : colors.verdictNotReady;
  return (
    <View style={[styles.pill, { backgroundColor: bg }]}>
      <Text style={[styles.text, { color: text }]}>{label}</Text>
    </View>
  );
}

function makeStyles(_colors: Colors) {
  return StyleSheet.create({
    pill: {
      paddingVertical: 7,
      paddingHorizontal: 16,
      borderRadius: radius.pill,
    },
    text: {
      fontFamily: fontFamily.bold,
      fontSize: 14,
    },
  });
}
